module.exports = __webpack_public_path__ + "static/media/paymate.dc83077c.png";